import React from "react";
import { FilterLabelProps, BaseInputFieldFilter } from "@duosoftbg/nacid-components";

const AcquiredSpecialityFilter = ({ label = "l.searchFilter.acquiredSpeciality", ...others }: FilterLabelProps) => {
  return (
    <>
      <BaseInputFieldFilter sm={6} md={3} fieldName={"acquiredSpeciality"} label={label} {...others} />
    </>
  );
};

export default AcquiredSpecialityFilter;
